export default {
    section: 'Tax Structure & Allocation',
    name: 'offer-letter-tax-structure',
    items: [
        {
            type: 'radio-list',
            text: 'Standard Terms',
            name: 'offer-letter-tax-structure-standard-terms',
            props: {
                row: true,
                tooltip: '91% Goodwill, 4% Restrictive Covenants, 5% Consulting',
                items: [
                    {
                        text: 'Yes',
                        value: 'yes'
                    },
                    {
                        text: 'No',
                        value: 'no'
                    }
                ]
            }
        },
        {
            type: 'text-field',
            text: 'Personal Goodwill',
            name: 'offer-letter-tax-structure-personal-goodwill',
            width: 3,
            props: {
                label: 'Personal Goodwill',
                format: 'percent'
            }
        },
        {
            type: 'text-field',
            text: 'Non-Compete/Non-Solicitation',
            name: 'offer-letter-tax-structure-non-compete',
            width: 3,
            props: {
                label: 'Non-Compete/Non-Solicitation',
                format: 'percent'
            }
        },
        {
            type: 'text-field',
            text: 'Consulting',
            name: 'offer-letter-tax-structure-consulting',
            width: 3,
            props: {
                label: 'Consulting',
                format: 'percent'
            }
        },
        {
            type: 'text-field',
            text: 'Tangible Assets',
            name: 'offer-letter-tax-structure-tangible-assets',
            width: 3,
            props: {
                label: 'Tangible Assets',
                format: 'percent'
            }
        },
        {
            type: 'text-field',
            text: 'Stock/Interest in Company',
            name: 'offer-letter-tax-structure-stock',
            width: 3,
            props: {
                label: 'Stock/Interest',
                format: 'percent'
            }
        },
        {
            type: 'textarea',
            text: 'Notes',
            name: 'offer-letter-tax-structure-notes',
            props: {}
        }
    ]
};


// WEBPACK FOOTER //
// ./src/components/offer-letter/valuation-data/tax-structure.js